/**
 * Client-side mirror of server/src/domain/businesses.ts.
 *
 * Only what the UI needs: the slug for URLs and the name for labels. The
 * server owns the ID mapping and the category-table names — nothing here is
 * used to build a query, so the two files cannot drift in a way that matters.
 */

export interface Business {
  slug: string;
  name: string;
  /** Businesses with their own gym_memberships database get a Klientat screen. */
  hasMemberships: boolean;
}

export const BUSINESSES: readonly Business[] = [
  { slug: 'stargym', name: 'Stargym', hasMemberships: true },
  { slug: 'missfit', name: 'Missfit', hasMemberships: true },
  { slug: 'starbar', name: 'Starbar', hasMemberships: false },
  { slug: 'stargroup', name: 'Stargroup', hasMemberships: false },
];

export function businessBySlug(slug: string | undefined): Business | undefined {
  if (!slug) return undefined;
  return BUSINESSES.find((b) => b.slug === slug.toLowerCase());
}
